import React from 'react';
import './SuccessBox.css';
const SuccessBox = (props) => {
    return <div className="success-box">
        <span className="success-icon"></span>
        <span> {props.children}</span>
    </div>
}

export default SuccessBox;